<template>
  <div style="width: 100%; background-color: #f7f7f7;">
    <div class="manage-title">
      <div class="manage-line"></div>
      <div class="manage-text">请选择要加入的小组</div>
    </div>

    <van-collapse v-model="activeNames">
      <van-radio-group v-model="radio">
      <van-collapse-item v-for="(item, index) in listTabDepartment" :key="index" :name="item.name" style="margin-bottom: 12px;" :border="false">
            <template #title>
              <van-radio :name="item.id">{{item.name}}</van-radio>
            </template>
            <van-cell-group v-for="(data, index) in item.departmentDatas" :key="index">
              <div class="flex-container">
                <van-image round width="50px" height="43px" :src="data.img" />
                <van-cell :label="data.account" :border="false">
                  <!-- 使用 title 插槽来自定义标题 -->
                  <template #title> 
                    <div class="manage-tags">
                        <div>{{data.name}}</div>
                        <div style="color:#3a71ffff; margin-left: 6px">{{getIsLeaderName(data, item.userId)}}</div>
                    </div>
                  </template>
                </van-cell>
              </div>
          </van-cell-group>
      </van-collapse-item>
      </van-radio-group>
    </van-collapse>
     <div class="footer">
      <van-button round type="info" @click="onUsersDepartmen">确定</van-button>
    </div>
  </div>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';

export default {
  props: {
    firmId: {
      type: String,
      default: ""
    },
    userId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      listTabDepartment: [],
      activeNames: [],
      list: [],
      radio: "",
      listQueryDepartment: {
        pageInfo: {
          pageSize: 1000,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        departmentId: "",
        firmId: "",
      },
    };
  },
  created() {
    this.onLoadDepartmentTab();
  },

  methods: {
    onClickRadio(val) {
        Toast(val);
    },
    getIsLeaderName(item, leaderUserId) {
      return this.getIsLeader(item, leaderUserId) ? "组长" : "组员"
    },
     getIsLeader(item, leaderUserId) {
      return item.id === leaderUserId
    },
     onUsersDepartmen() {
      request.post("/User/Department/SetUserDepartmen", {
        "userId": this.userId,
        "departmentId": this.radio
      }).then(() => {
         Toast("操作成功");
          this.$router.go(-1);
      }).catch(() => {
      });
    },
     onLoadDepartmentTab() {
      request.get("/User/Department/GetDepartmentList", { params: { firmId: this.firmId }})
        .then((res) => {
          this.listTabDepartment = res.data.data
          this.listTabDepartment.forEach(action => {
              this.onLoadDepartment(action.id)
          });
        })
        .catch(() => {});
    },
     onLoadDepartment(value) {
      this.listQueryDepartment.departmentId = value
      this.listQueryDepartment.firmId = this.firmId;

      var filterFomr = Object.assign({}, this.listQueryDepartment);
      request.post("/User/MyTeam/DepartmentUserList", filterFomr).then((res) => {
         this.listTabDepartment.forEach(action => {
          if(action.id === res.data.data.departmentId) {
            action.departmentDatas = res.data.data.data;
          }
             
          });
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less">
.flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 或者使用 flex-start, flex-end, center, space-around, space-evenly 等 */
}

.manage-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.manage-tags {
  display: flex;
  align-items: center;
}

.manage-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.manage-text {
  color: #333;
  margin-left: 6px;
}

.footer {
  position: fixed;
  bottom: 12px;
  right: 12px;
  width: 100%;
  text-align: right; /* 如果你想让按钮居中 */
}

</style>
